import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, memo } from 'react';
import { useTheme } from 'styled-components';
import { NotificationIndicator } from '../../../../Elements/NotificationIndicator';
import { ItemHeaderWrapper, ItemIcon, ItemTitle, ItemTitleText, Label, NotificationIndicatorWrapper } from './styled';
export const HeaderWrapper = memo(function HeaderWrapper({ match, icon, title, label, showIndicator, isOpened }) {
    const theme = useTheme();
    const clonedIcon = cloneElement(icon, {
        filled: !!match,
        color: match ? theme.colors.main : theme.colors.grey100_1,
        size: 20,
    });
    return (_jsxs(ItemHeaderWrapper, { children: [_jsxs(ItemIcon, { children: [clonedIcon, !isOpened && showIndicator && (_jsx(NotificationIndicatorWrapper, { children: _jsx(NotificationIndicator, { warning: true }) }))] }), _jsxs(ItemTitle, { children: [_jsx(ItemTitleText, { children: title }), label && _jsx(Label, { children: label })] })] }));
});
